/**
 * @fileoverview Slice Redux para gerenciamento do modal de landpage.
 * Controla estado de abertura/fechamento do LandpageManager.
 *
 * @module LandpageManagerSlice
 * @since 1.0.0
 */

import { createSlice } from '@reduxjs/toolkit';

const landpageManagerSlice = createSlice({
  name: 'landpageManager',
  initialState: {
    isOpen: false,
    showLandpage: false,
    activeLandpageConfig: null,
  },
  reducers: {
    /**
     * Abre o modal de gerenciamento de landpage.
     */
    openLandpageManager: (state) => {
      state.isOpen = true;
    },
    /**
     * Fecha o modal de gerenciamento de landpage.
     */
    closeLandpageManager: (state) => {
      state.isOpen = false;
    },
    /**
     * Exibe a landpage ativa no Workspace.
     */
    showLandpageView: (state) => {
      state.showLandpage = true;
    },
    /**
     * Oculta a landpage do Workspace.
     */
    hideLandpageView: (state) => {
      state.showLandpage = false;
    },
    /**
     * Armazena a configuração da landpage ativa buscada do backend.
     * @param {Object} action.payload - JSON de configuração da landpage
     */
    setActiveLandpage: (state, action) => {
      state.activeLandpageConfig = action.payload;
      state.showLandpage = true;
    },
  },
});

export const {
  openLandpageManager,
  closeLandpageManager,
  showLandpageView,
  hideLandpageView,
  setActiveLandpage,
} = landpageManagerSlice.actions;
export default landpageManagerSlice.reducer;
